<template>
  <div class="EntryformVue">
    <div class="wrap">
      <!--content start-->
      <div class="content entry-content">
        <!--banner-->
        <div class="et-banner dl-banner" v-if="router">
          <img  :src="router" alt=""/>
          <i class="et-modal-white"></i>
        </div>

        <div class="et-tabinner">
          <router-view></router-view>
        </div>

      </div>
      <!--content end-->

    </div>
    <!-- 返回顶部按钮 -->
    <div class="back-top" style="display:none" @click="ReturnTop">
      返回顶部
    </div>
    <!-- Modal -->
  </div>
</template>

<script>

    export default {
        data (){
        return {
          router : '',
          imgUrl: ''
        }
    }
    ,

    methods: {
        //操作按钮事件
      ReturnTop(){ //返回顶部
        $('html,body').stop().animate({scrollTop: '0px'}, 500);
      }
    },
    created: function () {
      var id = this.$route.params.id,
        that = this;
      this.$http.get(API.GetActivitieById, {params: {id: id}})
        .then(function (res) {
          //console.log(res.data.playbill.playbill)
          if (res.code == 0) {
            that.router = res.data.playbill.playbill;
            that.$nextTick(function () {
              var banWimg = $('.dl-banner').width();
              var banHimg = Math.ceil($('.dl-banner').width() / 2 * 1);
              var intervaLock;
              $('.dl-banner img').css({width: banWimg, height: banHimg, visibility: 'visible'});
            })

          }
        })
      //判断是否pc
     if (that.IsPC()) {
        window.location.href = API.IsPcName
      }
    },
    mounted: function () {
        //操作DOM
      //setTimeout(function(){
        //_vjTrack('')
      //},500)


    }

    }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/list.vue